<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="6">
        <b-form onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              v-model="form.prjTitle"
              @keyup.enter="query"
              type="search"
              :placeholder="'Search here...'"
              size="sm"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="searchFile()"
              v-if="allow('A')"
            >
              {{ $l('table_label_search_Document') || '文档搜索' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>

    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" size="medium">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_status') || '状态'">
              <dict-select
                v-model="form.prjStatus"
                clearable
                filterable
                style="width: 100%"
                url="/digitalCenter/common/dict/system"
                :body="{ dictType: 'prjStatus' }"
                size="small"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_customer') || '客户'">
              <dict-select
                style="width: 100%"
                clearable
                filterable
                v-model="form.custCode"
                url="/digitalCenter/common/dict/customer"
                size="small"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              >
              </dict-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l('INDEX.btn_reset_filter ') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
const initForm = {
  prjTitle: '',
  custCode: '',
  prjStatus: '',
  prjStatusList: [],
}
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      searchFileDialogVisible: false,
      form: {
        ...initForm,
      },
    }
  },
  methods: {
    query() {
      this.form.prjStatusList = []
      if (this.form.prjStatus) {
        this.form.prjStatusList.push(this.form.prjStatus)
      }
      this.$emit('setNavActive', 'all')
      this.$emit('submit', this.form)
    },
    // 高级查询
    advquery() {
      this.form.searchKey = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
      this.searchFileDialogVisible = false
    },
    searchFile() {
      this.form.prjStatusList = []
      if (this.form.prjStatus) {
        this.form.prjStatusList.push(this.form.prjStatus)
      }
      this.$emit('searchFile')
    },
  },
  mounted() {
    this.query()
  },
  activated() {
    this.query()
  },
}
</script>
